import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import LinkTo from '@di-shared/features/navigate/LinkTo';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import MyMaintenanceGradeError from '@di-shared/features/diag/cpo/MyMaintenanceGradeError';
import {ROUTE_PATHS} from '@di-shared/routes';
import {DiagCpoContentsProps} from '@di-shared/features/diag/cpo/DiagCpoContents';
import {emitEventLog} from '@di-shared/features/analytics';

function DiagCpoContentsError({vin}: DiagCpoContentsProps) {
  const {t} = useInferableTranslation();

  return (
    <main
      id="content"
      className="content page_car_management"
    >
      <section className="section section_car_certification">
        <section className="section section_certification_comprehensive">
          <div className="section_container">
            <div className="section_container_header">
              <h2
                className="title_medium_b"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T40046')}
              </h2>
              <div className="badge_box">
                <span className="badge badge_25px badge_filled_surface_container_lowest">{t('T20067')}</span>
              </div>
            </div>
            <span className="section_container_caption"></span>
            {/* [D] comprehensive_grade에 혜택 미대상일 경우 type_null 클래스 추가, 에러 케이스일 경우 type_error 클래스 추가 */}
            <div className={clsx('comprehensive_grade type_error')}>
              <span className="comprehensive_grade_item grade_etc">
                <span className="speech_bubble">{t('T20278')}</span>
              </span>
            </div>

            <ul className="statistics_info_list">
              <li className="statistics_info_item">
                <span className="statistics_info_key">{t('T20225')}</span>
                <span className="statistics_info_val">
                  <span className="statistics_info_number">{t('T20067')}</span>
                  <span className="statistics_info_unit"></span>
                </span>
              </li>
              <li className="statistics_info_item">
                <span className="statistics_info_key">{t('T20226')}</span>
                <span className="statistics_info_val">
                  <span className="statistics_info_number">{t('T20067')}</span>
                  <span className="statistics_info_unit"></span>
                </span>
              </li>
            </ul>
          </div>

          <div className="driving_banner type_square">
            <LinkTo
              to={ROUTE_PATHS.CPO_GUIDE.getFullPath()}
              className={'driving_banner_box'}
              onClick={() => {
                emitEventLog({
                  event: 'di_vehicle_management',
                  data_action: 'view banner',
                  data_name: t('T20229'),
                });
              }}
            >
              <span className="driving_banner_txtbox type_reverse">
                <strong className="driving_banner_title body_large_b">{t('T20229')}</strong>
                <span className="driving_banner_desc body_small_r">{t('T20228')}</span>
              </span>
              <span className="driving_banner_imgbox">
                <ImageSelector
                  className="driving_banner_img"
                  alt="driving_banner_img"
                  kiaLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  kiaDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  hyundaiLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  hyundaiDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_guide.png')}
                  genesisLightSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_guide.png')}
                  genesisDarkSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_guide.png')}
                />
              </span>
            </LinkTo>
          </div>
        </section>
        <MyMaintenanceGradeError />
        <section className="section section_certification_driving">
          <div className="section_container_header">
            <h3 className="title_medium_b">{t('T20226')}</h3>
            <div className="my_grade">
              <span className="my_grade_text">{t('T20067')}</span>
            </div>
          </div>
          <div className="section_container">
            <div className="certification_management_header">
              <strong
                className="certification_management_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20282')}
              </strong>
            </div>
            <div className="certification_management_content">
              <div className="empty_area">
                <span className="ic ic_caution_32px"></span>
                <span
                  className="body_small_r"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  {t('T30379')}
                </span>
              </div>
            </div>
          </div>

          <div className="driving_banner type_square">
            <LinkTo
              to={ROUTE_PATHS.SAFE_DRIVING.getFullPath(vin)}
              className="driving_banner_box"
            >
              <span className="driving_banner_txtbox type_reverse">
                <strong className="driving_banner_title body_large_b">{t('T30256')}</strong>
                <span className="driving_banner_desc body_small_r">{t('T30257')}</span>
              </span>
              <span className="driving_banner_imgbox">
                <ImageSelector
                  className="driving_banner_img"
                  alt="driving_banner_img"
                  kiaLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  kiaDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  hyundaiLightSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  hyundaiDarkSrc={() => import('@di-shared/assets/img/banner/hyundai/banner_certification_safe_score.png')}
                  genesisLightSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_safe_score.png')}
                  genesisDarkSrc={() => import('@di-shared/assets/img/banner/genesis/banner_certification_safe_score.png')}
                />
              </span>
            </LinkTo>
          </div>
        </section>
      </section>
    </main>
  );
}

export default DiagCpoContentsError;
